import { IconButton, ListItem, ListItemButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { isDark } from 'global/styles';

export const StyledSidebar = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  width: '300px',
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('lg')]: {
    width: '0px',
  },
  overflowY: 'scroll',
  position: 'fixed',
  zIndex: 100,
  transition: isMobile
    ? undefined
    : theme.transitions.create('width', { duration: theme.transitions.duration.complex }),
}));

export const StyledFullWidth = styled('div')({
  width: '100%',
  height: 'calc(100vh - 64px)',
});

export const StyledRowItem = styled(ListItemButton)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',

  '&.disabled': {
    opacity: 0.5,
  },

  '& .mainRow': {
    alignItems: 'flex-start',
  },

  '& .textContainer': {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(3),
    alignItems: 'flex-start',
  },
}));

export const StyledCloseIconButton = styled(IconButton)(({ theme }) => ({
  color: isDark(theme) ? theme.palette.common.white : theme.palette.primary.main,
}));

export const StyledDivider = styled(ListItem)(({ theme }) => ({
  borderBottom: `2px solid ${theme.palette.action.disabledBackground}`,
  marginBottom: theme.spacing(2),

  '& .dividertext': {
    marginBottom: -26,
    padding: theme.spacing(1),
    fontSize: 12,
    backgroundColor: theme.palette.background.default,
  },
}));
